import * as financingTypes from 'constants/enums/financingTypes'

export default {
  [financingTypes.OWN_FUNDS]: 'Vlastní prostředky',
  [financingTypes.MORTGAGE]: 'Hypotéka',
} as const
